import { cloneDeep } from 'lodash'

import { leadZero } from '@/utils'

export const timeParams = {
  $gt: '00:00:00',
  $lt: '23:59:59'
}

export const dateOptionsTime = {
  hour12: false,
  hour: '2-digit',
  minute: '2-digit'
}
export const dateOptionsTimeWithSeconds = {
  ...dateOptionsTime,
  second: '2-digit'
}

export function isSingleDate(value) {
  const dates = cloneDeep(value)
  if (dates.length === 2) {
    return dates.map(item => {
      item = new Date(item)

      return item.setHours(0, 0, 0, 0)
    }).reduce((a, b) => {
      return a === b
    })
  } else if (dates.length === 1) {
    return true
  }

  return false
}

export function getMonth() {
  const today = new Date()
  const month = today.getMonth()
  const year = today.getFullYear()

  const start = new Date(year, month, 1)
  start.setHours(0, 0, 0, 0)
  const end = new Date(year, month + 1, 0)
  end.setHours(23, 59, 59, 999)

  const previousStart = new Date(year, month - 1, 1)
  previousStart.setHours(0, 0, 0, 0)
  const previousEnd = new Date(year, month, 0)
  previousEnd.setHours(23, 59, 59, 999)

  return {
    current: {
      start,
      end
    },
    previous: {
      start: previousStart,
      end: previousEnd
    }
  }
}

export function getChosenDay($gt, $lt) {
  const gt = new Date()
  gt.setHours(0, 0, 0, 0)
  const lt = new Date(gt)
  if ($gt) {
    gt.setDate(gt.getDate() + $gt)
  }
  lt.setDate(lt.getDate() + 1)
  lt.setHours(0, 0, 0, 0)
  if ($lt) {
    lt.setDate(lt.getDate() + $lt)
  }

  return {
    $lt: lt.toISOString(),
    $gt: gt.toISOString()
  }
}
export function getChosenMonth($gt, $lt) {
  const gt = new Date()
  gt.setHours(0, 0, 0, 0)
  const lt = new Date(gt)
  if ($gt) {
    gt.setMonth(gt.getMonth() + $gt)
  }
  lt.setDate(lt.getDate() + 1)
  lt.setHours(0, 0, 0, 0)
  if ($lt) {
    lt.setMonth(lt.getMonth() + $lt)
  }

  return {
    $lt: lt.toISOString(),
    $gt: gt.toISOString()
  }
}

export function getHammerTime(date = new Date().setHours(0, 0, 0, 0)) {
  const parseDate = new Date(date)

  return [ leadZero(parseDate.getHours()), leadZero(parseDate.getMinutes()) ].join(':')
}

export function getISODate(date) {
  if (date) {
    const parseDate = new Date(date)

    return [
      parseDate.getFullYear(),
      leadZero(parseDate.getMonth() + 1),
      leadZero(parseDate.getDate())
    ].join('-')
  }
}

export function getUnix(date, inSeconds) {
  if (date) {
    const parseDate = new Date(date)
    if (parseDate) {
      if (inSeconds) {
        return parseInt((parseDate.getTime() / 1000).toString())
      }

      return parseInt(parseDate.getTime().toString())
    }
  }
}

export function getRUDate(date) {
  if (date) {
    const parseDate = new Date(date)

    return [
      leadZero(parseDate.getDate()),
      leadZero(parseDate.getMonth() + 1),
      parseDate.getFullYear()
    ].join('.')
  }
}

export function getLocaleDateString(
  date,
  locale = 'ru',
  options = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  }
) {
  return new Date(date).toLocaleDateString(locale, options)
}
export function getLocaleTimeString(date, options = {}) {
  const params = {
    hour: options.hour || '2-digit',
    minute: options.minute || '2-digit'
  }
  if (options.second !== false) {
    params.second = options.second || '2-digit'
  }
  const locale = options.locale || 'ru'
  const source = new Date(date)
  const time = source.toLocaleTimeString(locale, params)
  const ms = `${source.getMilliseconds()}`.padStart(3, '0')

  if (options.milliseconds) {
    return time + `.${ms}`
  }

  return time
}

export function computeDateDate(plusDate = 0, relativeDate = new Date()) {
  return relativeDate.setDate(relativeDate.getDate() + plusDate)
}

export function getYesterday() {
  return computeDateDate(-1)
}

export function getUnixSeconds() {
  return parseInt((Date.now() / 1000).toString())
}

export const getCreatedAtByPreset = preset => {
  const timeOptions = {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  }

  const getTodayDates = (shift = 0) => {
    const date = new Date()

    return [ date.setHours(0, 0, 0, 0) - shift, date.setHours(23, 59, 59, 999) - shift ]
  }
  const getDatesWeek = (current = false) => {
    const date = new Date()
    date.setHours(0, 0, 0, 0)

    let first = new Date(date.setDate(date.getDate() - date.getDay() - 6)).setHours(0, 0, 0, 0)
    let last = new Date(date.setDate(date.getDate() + 6)).setHours(23, 59, 59, 999)
    if (current) {
      first = new Date(date.setDate(date.getDate() - date.getDay() + 1)).setHours(0, 0, 0, 0)
      last = new Date(date.setDate(date.getDate() - date.getDay() + 7)).setHours(23, 59, 59, 999)
    }

    return [ first, last ]
  }
  const getDatesMonth = (current = false) => {
    const date = new Date()
    date.setHours(0, 0, 0, 0)

    let first = new Date(date.getFullYear(), date.getMonth() - 1, 1).setHours(0, 0, 0, 0)
    let last = new Date(date.getFullYear(), date.getMonth(), 0).setHours(23, 59, 59, 999)
    if (current) {
      first = new Date(date.getFullYear(), date.getMonth(), 1).setHours(0, 0, 0, 0)
      last = new Date(date.getFullYear(), date.getMonth() + 1, 0).setHours(23, 59, 59, 999)
    }

    return [ first, last ]
  }
  const getHummerTime = date => {
    return date.toLocaleTimeString('ru-RU', timeOptions)
  }
  const getTime = () => {
    const result = {
      $gt: '00:00:00',
      $lt: '23:59:59'
    }
    const date = new Date()
    date.setHours(0, 0, 0, 0)
    result.$gt = getHummerTime(date)
    date.setHours(23, 59, 59, 999)
    result.$lt = getHummerTime(date)

    return result
  }
  const getCurrentTime = (shift = 0) => {
    const date = new Date()
    const result = {
      $gt: getHummerTime(date),
      $lt: getHummerTime(date)
    }
    date.setMilliseconds(date.getMilliseconds() - shift)
    result.$gt = getHummerTime(date)

    return result
  }

  const shortPresets = {
    'minutes.5': {
      date: getTodayDates(),
      time: getCurrentTime(300000)
    },
    'minutes.15': {
      date: getTodayDates(),
      time: getCurrentTime(900000)
    },
    'minutes.30': {
      date: getTodayDates(),
      time: getCurrentTime(1800000)
    },
    'hours.1': {
      date: getTodayDates(),
      time: getCurrentTime(3600000)
    },
    'hours.3': {
      date: getTodayDates(),
      time: getCurrentTime(10800000)
    },
    'hours.6': {
      date: getTodayDates(),
      time: getCurrentTime(21600000)
    }
  }
  const longPresets = {
    yesterday: {
      date: getTodayDates(86400000),
      time: getTime()
    },
    today: {
      date: getTodayDates(),
      time: getTime()
    },
    'last.week': {
      date: getDatesWeek(),
      time: getTime()
    },
    'current.week': {
      date: getDatesWeek(true),
      time: getTime()
    },
    'last.month': {
      date: getDatesMonth(),
      time: getTime()
    },
    'current.month': {
      date: getDatesMonth(true),
      time: getTime()
    }
  }

  const generateCreatedAtFromPreset = value => {
    const { date, time } = value

    let $gt = new Date()
    if (date[0]) {
      $gt = new Date(date[0])
    }
    let $lt = new Date($gt)
    if (date[1]) {
      $lt = new Date(date[1])
    }

    $gt.setHours(...timeToArrayOfNumbers(time.$gt))
    $lt.setHours(...timeToArrayOfNumbers(time.$lt))

    return {
      $gt: $gt.toISOString(),
      $lt: $lt.toISOString()
    }
  }

  switch (preset) {
    case 'minutes.5':
    case 'minutes.15':
    case 'minutes.30':
    case 'hours.1':
    case 'hours.3':
    case 'hours.6': {
      return generateCreatedAtFromPreset(shortPresets[preset])
    }
    case 'yesterday':
    case 'today':
    case 'last.week':
    case 'current.week':
    case 'last.month':
    case 'current.month': {
      return generateCreatedAtFromPreset(longPresets[preset])
    }
  }
}

export const processFilter = (filter, params = {}, propsToRemove = [ 'createdAtPreset', '$scope' ]) => {
  filter = cloneDeep(filter)
  if (filter.createdAtPreset) {
    filter.createdAt = getCreatedAtByPreset(filter.createdAtPreset)

    for (const prop of propsToRemove) {
      delete filter[prop]
    }
  }

  for (const key in params) {
    const value = params[key]
    if (value !== undefined) {
      filter[key] = value
    }
  }

  return filter
}

export const timeToArrayOfNumbers = value => {
  return value.split(':').map((string, index) => {
    let number = parseInt(string) || 0
    if (index === 0 && number === 24) {
      number = 0
    }

    return number
  })
}
export const timeToArrayStringsWithLeadZero = value => {
  return timeToArrayOfNumbers(value).map(item => {
    return leadZero(item)
  })
}

export const calculateDateRange = date => {
  const maxDateRange = 186 // Максимальный диапазон в днях
  const currentDate = new Date(date)

  // Рассчитываем минимальную дату (186 дней назад от выбранной даты)
  const min = new Date(currentDate)
  min.setDate(min.getDate() - maxDateRange)

  // Рассчитываем максимальную дату (186 дней вперед от выбранной даты)
  const max = new Date(currentDate)
  max.setDate(max.getDate() + maxDateRange)

  return {
    min,
    max
  }
}

export function formatDateWithCheckYear(value) {
  const dateNow = new Date()
  const date = new Date(value)
  const options = {
    month: 'short',
    day: 'numeric'
  }
  if (date.getFullYear() !== dateNow.getFullYear()) {
    options.year = 'numeric'
  }

  return date.toLocaleDateString(this.locale, options)
}
